export enum ListingType {
  POLICY = "policy",
  CLAIM = "claim",
  FILE = "file",
  LIST = "list",
  MARKETING = "marketing",
  COMMISSION = "commission",
  AGENT = "agent",
  CONTACT = "contact",
  BLAST = "blast",
  REPORTING = "reporting",
  INSURANCE = "insurance",
  INSURER = "insurer",
  INSURANCE_CATEGORY = "insurance-categories",
  PRODUCT_CATEGORY = "product-category",
  PARTNER = "partner",
  PRODUCT = "product",
  ACCESS_MANAGEMENT = "access-management",
  USER = "user",
  ROLE = "role",
  PRIVILEGE = "privilege",
  CAMPAIGN_MANAGEMENT = "campaign-management",
  CAMPAIGN = "campaign",
  CUSTOMER_MANAGEMENT = "customer-management",
  CUSTOMER = "customer",
  CUSTOMER_EMAIL = "customer-email",
  ORGANISATION = "organisation",
  ORGANIZATION = "organization",
  HIERARCHY_MANAGEMENT = "hierarchy-management",
  LEVEL = "level",
  SECTION = "section",
  QUOTATION = "quotation",
  OTP = "otp",
  FORGET_PASSWORD = "forget-password",
  CHANGE_PASSWORD = "change-password",
  VERIFY = "verify",
  FINISH = "finish",
  DASHBOARD = "dashboard",
  NEW_POLICY = "new-policy",
  PROFILE = "profile",
  EDIT = "edit",
  CREATE = "create",
  INTERNAL_TOOLS = "internal-tools",
  ADHOC_REQUEST_FORM = "adhoc-request-form",
  CLAIM_FORM_BUILDER = "claim-form-builder",
  RULE_ENGINE = "rule-engine",
  WORKFLOW_ENGINE = "workflow-engine",
  PERSONAL_LINES = "personal-lines",
  PARTNERSHIP = "partnership",
  PAYOUT_HISTORY = "payout-history",
  QAPP_INSURER_MANAGEMENT = "qoala-app-management",
  QUOTE = "quote",
  ENDORSEMENT = "endorsement",
  RENEWAL = "renewal",
  QOALA_APP_MALAYSIA = "qoala-app-malaysia",
  COMMERCIAL_LINES = "commercial-lines",
  PAYMENT_MANAGEMENT = "payment-management",
  INVOICE = "invoice",
  ITEM = "item",
  CLAIM_POOL = "claim-pool",
  CLAIM_DISBURSEMENT_LIST = "claim-disbursement",
  Q_CARE = "q-care",
  PRODUCT_MANAGEMENT = "product-management",
  PRODUCT_LIST = "products",
  PRODUCT_CATEGORY_LIST = "product-categories",
  FINANCE_OPERATION = "finance-operation",
  FINANCE_OPERATION_ADDITIONAL_FEE_REQUEST = "additional-fee-request",
  FINANCE_OPERATION_INVOICE_LIST = "invoice",
  FINANCE_OPERATION_PAYMENT_TO_INSURER_REQUEST = "payment-to-insurer-request",
  FINANCE_OPERATION_PAYMENT_TO_INSURER_TRANSACTION = "payment-to-insurer-transaction",
  FINANCE_OPERATION_COMMISSION_REQUEST = "commission-request",
  FINANCE_OPERATION_COMMISSION_FROM_INSURANCE_TRANSACTION = "commission-from-insurance-transaction",

  /* Finance and Accounting */
  FINANCE_AND_ACCOUNTING = "finance-accounting",
  /* Internal tools Form Management */
  FORM_MANAGEMENT = "form-management",

  CREDIT_LIFE = "credit-life",
  SPK_REPORT = "spk-report",
  METABASE = "metabase",
  REFUND = "refund",
  AGENT_MANAGEMENT = "agent-management",
  CANCEL_REQUEST_POLICY = "cancel-request-policy",
  CANCELLED_POLICY = "cancelled-policy",
  BROKER_MANAGEMENT = "broker-management",
  BANK_MANAGEMENT = "bank-management",
}
